import Link from 'next/link';

import styled from '@emotion/styled';
import { useTranslations } from 'next-intl';

import { HANA_LINK } from '@web/features/const';
import { HanaIcon } from '@web/features/hub-rework/brand-icons';
import { GenericHubTile } from '@web/features/hub-rework/GenericHubTile';
import { useDesignsTokenTheme } from '@web/ui/theme/ThemeProvider';

import LottieAnimation from '../LottieAnimation';

import HanaAiAgentDarkLottie from './hana-dark.json';
import HanaAiAgentLightLottie from './hana-light.json';

const LottieContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 11.25rem;
  overflow: hidden;

  > * {
    width: 100%;
    max-width: 11.25rem;
    max-height: 100%;
  }
`;

// Tighten the underlying GenericHubTile's Content block so the illustration
// can breathe vertically between the title chip and the subtitle.
const TunedHubTile = styled(GenericHubTile)`
  /* TopRowContainer is absolute at top:0 with 2rem padding; give the
     illustration headroom below it so it never crowds the title chip. */
  > div:nth-of-type(2) {
    margin-top: 3.5rem;
  }
  /* Content block: trim default 2rem padding-top so the illustration
     sits visually centered between chip and subtitle. */
  > div:nth-of-type(3) {
    padding-top: 0.5rem;
    gap: 1.25rem;
  }
`;

export const HanaAiAgentTile = () => {
  const { isDarkMode } = useDesignsTokenTheme();
  const t = useTranslations();

  return (
    <Link href={HANA_LINK} target="_blank">
      <TunedHubTile
        variant="top"
        title={t('HANA_AI_AGENT_HUB_TILE')}
        subtitle={t('HANA_AI_AGENT_HUB_TILE_SUBTITLE')}
        description={t('HANA_AI_AGENT_HUB_TILE_DESCRIPTION')}
        linkText={t('HANA_AI_AGENT_HUB_TILE_LINK_TEXT')}
        href={HANA_LINK}
        illustration={
          <LottieContainer>
            <LottieAnimation
              animationData={
                isDarkMode ? HanaAiAgentDarkLottie : HanaAiAgentLightLottie
              }
            />
          </LottieContainer>
        }
        badge={<HanaIcon size="3000" />}
      />
    </Link>
  );
};
